import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, toRefs, ref, watch, watchEffect, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import type moment from '@nuxtjs/moment';
import type { DefineComponent } from 'vue';
import { useSyncedUniqueInterval } from '~/core/composables/useSyncedUniqueInterval';

interface Props {
    tag?: string | DefineComponent;
    date: string | Date;
    locale?: 'i18n' | 'en' | 'es' | 'ja' | 'ko' | 'pt' | 'ru' | 'th' | 'vi' | 'zh-cn',
}


const localeToMomentLocaleMap = {
    'en': 'en',
    'es': 'es',
    'ja': 'jp',
    'ko': 'ko',
    'pt': 'pt',
    'ru': 'ru',
    'th': 'th',
    'vi': 'vn',
    'zh-cn': 'zh',
};

export default /*#__PURE__*/_defineComponent({
  __name: 'TimePassed',
  props: {
    tag: { default: 'span' },
    date: null,
    locale: { default: 'i18n' }
  },
  setup(__props: any) {

const props = __props as { tag: string | DefineComponent, date: string | Date, locale: 'i18n' | 'en' | 'es' | 'ja' | 'ko' | 'pt' | 'ru' | 'th' | 'vi' | 'zh-cn' };

const { $moment, i18n } = useContext() as ReturnType<typeof useContext> & { $moment: typeof moment };



const {
    tag,
    date,
    locale,
} = toRefs(props);

const currentLocale = computed(() => i18n.locale);
const momentDate = ref($moment(date.value));

watch(date, (val) => {
    momentDate.value = $moment(val);
    momentDate.value.locale(localeToMomentLocaleMap[locale.value] || currentLocale.value);
}, { immediate: true });

watchEffect(() => {
    momentDate.value.locale(localeToMomentLocaleMap[locale.value] || currentLocale.value);
});

const timePassed = computed(() => momentDate.value.fromNow());
let updateIntervalCleanupFunction: () => void = null;
onMounted(() => {
    updateIntervalCleanupFunction = useSyncedUniqueInterval(
        30 * 1000,
        () => {
            momentDate.value = $moment(date.value);
            momentDate.value.locale(localeToMomentLocaleMap[locale.value] || currentLocale.value);
        }
    );
});

onUnmounted(() => {
    updateIntervalCleanupFunction?.();
    updateIntervalCleanupFunction = null;
});


return { __sfc: true,localeToMomentLocaleMap, $moment, i18n, props, tag, date, locale, currentLocale, momentDate, timePassed, updateIntervalCleanupFunction }
}

})